import styled from 'styled-components';
import { colors } from '../../../../config/styles';
import { SingleSelectMenu } from '../../../../components/Dropdown';
import { theme } from '../../../../styles/theme';

export const GridContainer = styled.div`
  border: 1px solid ${theme.colors.border};
`;

export const ErrorContainer = styled.div`
  width: 100%;
  color: ${colors.mainError};
`;

export const CheckBoxWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: right;
`;

export const MapToFieldDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const PlainTypeWrapper = styled.div`
  padding-left: 9px;
`;

export const StyledTypeOverrideSelectMenu = styled(SingleSelectMenu)`
  width: 90px;
`;
